import React from "react";
import { ROLES, type Role } from "../models/auth";

interface Props {
  /** Si no hay rol, usa null (no pases undefined con exactOptional). */
  value?: Role | null;
  disabled?: boolean;
  onChange: (role: Role | null) => void; // null = “sin rol”
  className?: string;
}

export default function RoleSelect({
  value = null,
  disabled,
  onChange,
  className,
}: Props): React.ReactElement {
  return (
    <select
      className={`rounded border border-surface bg-surface px-2 py-1 ${
        className ?? ""
      }`}
      value={value ?? ""}
      onChange={(e) =>
        onChange(e.target.value ? (e.target.value as Role) : null)
      }
      disabled={!!disabled}
    >
      <option value="">(sin rol)</option>
      {ROLES.map((r) => (
        <option key={r} value={r}>
          {r}
        </option>
      ))}
    </select>
  );
}
